import {createReducer} from '../../utilities';

import {scope} from '../../../actions/app/support/tournament';
import {
  REQUEST_FETCH_TOURNAMENT,
  SUCCESS_FETCH_TOURNAMENT,
  FAIL_FETCH_TOURNAMENT,
  REQUEST_UPDATE_TOURNAMENT_IS_PUBLIC,
  SUCCESS_UPDATE_TOURNAMENT_IS_PUBLIC,
  FAIL_UPDATE_TOURNAMENT_IS_PUBLIC,
  REQUEST_UPDATE_TOURNAMENT_NAME,
  SUCCESS_UPDATE_TOURNAMENT_NAME,
  FAIL_UPDATE_TOURNAMENT_NAME,
} from '../../../actions/entities/tournament';

const initialTournamentSupportState = {
  id: null,
  info: {
    isFetching: false,
    lastAction: null,
    lastPayload: {},
    needRefresh: true,
    updatedAt: null,
    success: false,
    error: false,
  },
};

function request(state, action) {
  return {
    ...state,
    info: {
      isFetching: true,
      lastAction: action.type,
      lastPayload: action.payload,
      needRefresh: false,
      updatedAt: null,
      success: false,
      error: false,
    },
  };
}

function success(state, action) {
  const {id, tournamentId, receivedAt, success} = action;
  return {
    ...state,
    id: id || state.id,
    info: {
      ...state.info,
      isFetching: false,
      lastPayload: tournamentId,
      needRefresh: false,
      updatedAt: receivedAt,
      success,
      error: false,
    },
  };
}

function fail(state, action) {
  const {error, payload, type} = action;
  return {
    ...state,
    id: type === FAIL_FETCH_TOURNAMENT ? null : state.id,
    info: {
      ...state.info,
      isFetching: false,
      lastPayload: payload,
      needRefresh: false,
      success: false,
      error,
    },
  };
}

export default createReducer(
  initialTournamentSupportState,
  {
    [REQUEST_FETCH_TOURNAMENT]: request,
    [SUCCESS_FETCH_TOURNAMENT]: success,
    [FAIL_FETCH_TOURNAMENT]: fail,

    [REQUEST_UPDATE_TOURNAMENT_NAME]: request,
    [SUCCESS_UPDATE_TOURNAMENT_NAME]: success,
    [FAIL_UPDATE_TOURNAMENT_NAME]: fail,

    [REQUEST_UPDATE_TOURNAMENT_IS_PUBLIC]: request,
    [SUCCESS_UPDATE_TOURNAMENT_IS_PUBLIC]: success,
    [FAIL_UPDATE_TOURNAMENT_IS_PUBLIC]: fail,
  },
  scope,
);



// WEBPACK FOOTER //
// ./src/reducers/app/support/tournament.js